export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Bold.35112223.eot";